import { Reply } from '../../components/Reply Kit/ReplyKitPopup';
import { host } from '../API';

export const getTotalRepliesOnKit = async function (app: string, token: string) {
    const endpoint = host + "api/replykit/" + app + "/total/";

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to retrieve your Reply kit replies. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const getRepliesOnKit = async function (app: string, token: string) {
    const endpoint = host + "api/replykit/" + app + "/replies";

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to retrieve your Reply kit replies. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const createReplyOnKit = async function (app: string, token: string, reply: Reply) {
    const endpoint = host + "api/replykit/" + app + "/";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ reply: reply }),
        });

    if (!response.ok) {
        const message = 'Failed to create a reply on your Reply kit. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const deleteReplyOnKit = async function (replyId: string, token: string) {
    const endpoint = host + "api/replykit/" + replyId + "/";

    const response = await fetch(
        endpoint,
        {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
            },
        });

    if (!response.ok) {
        const message = 'Failed to delete a reply on your Reply kit. Please check your connection and try again.';
        throw new Error(message);
    }

    return;
}

export const disableReplyOnKit = async function (reply: Reply, token: string) {
    const endpoint = host + "api/replykit/" + reply.id;

    const response = await fetch(
        endpoint,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
            body: JSON.stringify({
                reply: reply
            }),
        });

    if (!response.ok) {
        const message = 'Failed to disable the reply on your Reply kit. Please check your connection and try again.';
        throw new Error(message);
    }

    return;
}

export const generateReplyPreviewOnKit = async function (app: string, token: string, language: string, category: string) {
    const endpoint = host + "api/replykit/" + app + "/wingman";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ language: language, category: category }),
        });

    if (!response.ok) {
        const message = 'Failed to generate reply preview. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const getTotalReplyAutomationsOnKit = async function (app: string, token: string) {
    const endpoint = host + "api/replykit/" + app + "/automations/total/";

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to retrieve reply automations. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const getAutomationsOnKit = async function (app: string, token: string) {
    const endpoint = host + "api/replykit/" + app + "/automations/";

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to retrieve reply automations. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const getLanguages = async function (token: string) {
    const endpoint = host + "api/replykit/languages";

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to retrieve available languages. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const createAutomationOnKit = async function (app: string, token: string, automation: any) {
    const endpoint = host + "api/replykit/" + app + "/automations/full";
    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ automation: automation }),
        });

    if (!response.ok) {
        const message = 'Failed to create reply automation. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const deleteAutomationOnKit = async function (automationId: string, token: string) {
    const endpoint = host + "api/replykit/automations/" + automationId + "/";

    const response = await fetch(
        endpoint,
        {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
            },
        });

    if (!response.ok) {
        const message = 'Failed to delete reply automation. Please check your connection and try again.';
        throw new Error(message);
    }

    return;
}

export const disableAutomationOnKit = async function (automation: any, token: string) {
    const endpoint = host + "api/replykit/automations/" + automation.id + "/";

    const response = await fetch(
        endpoint,
        {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
            body: JSON.stringify({
                automation: automation.is_active = !automation.is_active
            }),
        });

    if (!response.ok) {
        const message = 'Failed to disable reply automation. Please check your connection and try again.';
        throw new Error(message);
    }

    return;
}

export const getAutomationExecutionsLogOnKit = async function (app: string, token: string) {
    const endpoint = host + "api/replykit/automations/" + app + "/logs/";

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to retrieve automation executions log. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}